import { calcHeight, calcWidth } from '../../utils/dimensions';

export const MAX_VIDEO_LENGTH = 300; //seconds
export const MAX_MEDIA_SIZE = 250 * 1024 * 1024; // 250 Mb in bytes
export const DEFAULT_IMAGE_WIDTH = calcWidth(248);
export const DEFAULT_IMAGE_HEIGHT = calcHeight(361);
